import React, { useEffect, useRef, useState } from 'react';
import './Marquee.css';
import { siteConfig } from '../data/content';

const Marquee = ({ text, speed = 120 }) => {
  const raw = text || siteConfig.marqueeText || '';
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [display, setDisplay] = useState(raw);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    const contentEl = contentRef.current;
    if (!container || !contentEl) return;
    if (!raw) return;

    requestAnimationFrame(() => {
      const containerW = container.getBoundingClientRect().width;
      const unitText = `${raw} \u00A0`;

      const temp = document.createElement('span');
      temp.style.position = 'absolute';
      temp.style.left = '-9999px';
      temp.style.whiteSpace = 'nowrap';
      temp.className = 'marquee__text';
      document.body.appendChild(temp);

      temp.textContent = unitText;
      const unitW = temp.getBoundingClientRect().width;

      let repeated = unitText;
      let repeatedW = unitW;
      while (repeatedW < containerW + unitW && repeated.length < 2000) {
        repeated += unitText;
        temp.textContent = repeated;
        repeatedW = temp.getBoundingClientRect().width;
      }

      document.body.removeChild(temp);

      setDisplay(repeated);
      const root = container;
      root.style.setProperty('--unit-w', `${unitW}px`);
      const duration = Math.max(8, Math.round(unitW / speed));
      root.style.setProperty('--marquee-duration', `${duration}s`);
    });
  }, [raw, speed]);

  if (!raw) return null;

  return (
    <div
      className={`marquee${isPaused ? ' marquee--paused' : ''}`}
      ref={containerRef}
      aria-hidden={raw === '' ? 'true' : 'false'}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onFocus={() => setIsPaused(true)}
      onBlur={() => setIsPaused(false)}
    >
      <div className="marquee__inner">
        <span className="marquee__text" ref={contentRef}>{display}</span>
      </div>
    </div>
  );
};

export default Marquee;
